<template>
  <div class="carImg">
    <div
      class="currentImg"
      @mousemove="mousemove"
      @mousedown="mousedown"
      @mouseup="mouseup"
      @mouseleave="mouseleave"
      :style="'background-image:url(' + imgList[currentIndex] + ')'"
    ></div>
    <img
      style="display:none"
      v-for="item in imgList"
      :key="item"
      :src="item"
      alt=""
    />
  </div>
</template>

<script>
var throttle = true;
export default {
  name: "ThreeDRotate",
  props: {
    imgsPath: {
      require: true,
      type: String
    },
    totalNum: {
      require: true,
      type: Number
    }
  },
  data() {
    return {
      imgList: [],
      move: false,
      currentPosition: 0,
      currentIndex: 0
    };
  },
  mounted() {
    for (let i = 0; i < this.totalNum; i++) {
      this.imgList.push(
        require("../../" + this.imgsPath + "/旋转.1." + (i + 1) + ".png")
      );
    }
  },
  methods: {
    mousemove(e) {
      if (this.move) {
        if (throttle) {
          throttle = false;
          this.currentPosition = e.offsetX;
          setTimeout(() => {
            throttle = true;
          }, 5);
        }
      }
    },
    mousedown() {
      setTimeout(() => {
        this.move = true;
      }, 50);
    },
    mouseup() {
      this.move = false;
    },
    mouseleave() {
      this.move = false;
    }
  },
  watch: {
    currentPosition: function(newValue, oldValue) {
      let distance = newValue - oldValue;
      if (distance < 0) {
        if (this.currentIndex == this.totalNum - 1) {
          this.currentIndex = 0;
        } else {
          this.currentIndex += 1;
        }
      } else if (distance > 0) {
        if (this.currentIndex == 0) {
          this.currentIndex = this.totalNum - 1;
        } else {
          this.currentIndex -= 1;
        }
      }
    }
  }
};
</script>
<style lang="less">
.currentImg,
.carImg {
  width: 100%;
  height: 100%;
  background-size: 100% 100%;
  cursor: move;
}
</style>
